import * as Icons from '@ant-design/icons'
import { Button, Space } from 'antd'

import { StyledHeaderButton } from '../../layout/styled/header'
import { AppHeaderPortal } from '../../layout/components/header-portal'

import { StyledActionBar } from '@shared/styled/action-bar'
import { useAppointmentsTableActions } from '../hooks/use-table-actions'
import { AppointmentsTableFilter } from './table-filters'
import { useAuth } from '@modules/me/hooks'

export const AppointmentsTableActions = () => {
  const {
    selection,
    handleFetch,
    handleResetSelection,
    handleSelectAll,
    handleReset,
    handleAction,
    filtersIsVisible,
    openFilters,
    closeFilters,
    goToCreate,
  } = useAppointmentsTableActions()

  const { can } = useAuth()

  return (
    <AppHeaderPortal>
      {!!selection.length && (
        <StyledActionBar $visible={!!selection.length} $flex={true}>
          <StyledActionBar.Selection>
            <Icons.CloseCircleTwoTone role='icon' onClick={handleResetSelection} />
            <span>{selection.length} sətir seçilib</span>
          </StyledActionBar.Selection>
          <Space size={8}>
            {can(69) && (
              <Button type='primary' danger={true} icon={<Icons.DeleteOutlined />} onClick={() => handleAction('remove')}>
                Sil
              </Button>
            )}
          </Space>
        </StyledActionBar>
      )}
      {!selection.length && (
        <StyledActionBar $visible={!selection.length} $flex={true}>
          <Space size={8}>
            {can(66) && (
              <StyledHeaderButton $ghost={true} icon={<Icons.PlusCircleOutlined />} onClick={goToCreate}>
                Yeni
              </StyledHeaderButton>
            )}
            <StyledHeaderButton $ghost={true} onClick={handleSelectAll} icon={<Icons.CheckCircleOutlined />}>
              Hamısını seç
            </StyledHeaderButton>
            <StyledHeaderButton $ghost={true} onClick={handleFetch} icon={<Icons.ReloadOutlined />}>
              Yenilə
            </StyledHeaderButton>
            <StyledHeaderButton $ghost={true} onClick={handleReset} icon={<Icons.ClearOutlined />}>
              Sıfırla
            </StyledHeaderButton>
          </Space>
          <Space size={8}>
            <StyledHeaderButton $ghost={true} onClick={openFilters} icon={<Icons.FilterOutlined />}>
              Filterlə
            </StyledHeaderButton>
          </Space>
        </StyledActionBar>
      )}
      <AppointmentsTableFilter onCancel={closeFilters} visible={filtersIsVisible} />
    </AppHeaderPortal>
  )
}
